import { render, staticRenderFns } from "./GameLogsView.vue?vue&type=template&id=7c9d1730&scoped=true&"
import script from "./GameLogsView.vue?vue&type=script&lang=js&"
export * from "./GameLogsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9d1730",
  null
  
)

export default component.exports